<div class="alert alert-info d-flex justify-content-center align-items-center" role="alert">
    <i class="pi pi-exclamation-circle mr-2"></i>
    <span><strong>Attested Invoice Recipients: </strong>Shared inboxes and selected contacts will receive an <strong>email</strong> with the PDF of every invoice that is attested.</span>
</div>

<pcg-ba-shared-inboxes class="d-block mb-4 p-1" />

<div class="contacts-container d-flex w-100 p-1">
    <pcg-ba-contacts-list 
        #availableTable
        class="mr-4 w-100" 
        [isSelected]="false" 
        (update)="updateTable()"
    />

    <pcg-ba-contacts-list 
        #selectedTable
        class="w-100" 
        [isSelected]="true" 
        (update)="updateTable()"
    />
</div>